import React from 'react';
import ImagecropperContainer from '../../Componant/Bonus-Ui/ImageCropper';

const Imagecropper = () => {
  return (
    <div className='page-body'>
      <ImagecropperContainer />
    </div>
  );
};

export default Imagecropper;
